/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fg } from '@atlassian/jira-feature-gating';

export const getJpdViewsServicePathPrefix = (): string =>
	fg('jpd_views_service_multi_region_route')
		? '/gateway/api/jpd/views-mrg'
		: '/gateway/api/jpd/views';
